import TbTruckDelivery from '../icons/TbTruckDelivery';
import BsPhone from '../icons/BsPhone';
import BsChatRightText from '../icons/BsChatRightText';
import BsPeopleFill from '../icons/BsPeopleFill';
import { useContext } from 'react';
import AppContext from '../components/context/AppContext';
import { useMemo } from 'react';

const useFeatures = () => {
    const { appContext } = useContext(AppContext);
    const appConfig = appContext.config.themeConfig;
    const featureList = useMemo(() => [{
        heading: 'Free Shipping in USA',
        text: 'All Orders over ' + appConfig.freeShippingAmount,
        Icon: TbTruckDelivery,
    }, {
        heading: 'Give Us A Call',
        text: '+1 (800) 210-8170',
        link: 'tel:+1 (800) 210-8170',
        Icon: BsPhone,
    }, {
        heading: 'Chat With Us',
        text: 'From 9am to 3pm EST',
        Icon: BsChatRightText,
    }, {
        heading: 'Bow Specialist',
        text: 'Ready to help!',
        Icon: BsPeopleFill,
    }], [appConfig]);
    return featureList;
};

export default useFeatures;